// extracted by mini-css-extract-plugin
module.exports = {"CodeBlock":"CodeBlock-styles-module--CodeBlock--3QefH","title":"CodeBlock-styles-module--title--1JDcB"};